<template>
    <div class="md-similar-home classic" v-if="exist" v-show="visible">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title">
                <div v-html="formatFontSize(title, '--mg-title-size')"></div>
                <div
                    class="unlike"
                    @click="unlike"
                >
                    <span class="iconfont icon-reset"></span>{{ $t('md-similar-home.unlike') }} ?
                </div>
            </div>
            <h3 class="subTitle" v-if="showSubTitle">{{ subTitle }}</h3>
            <HouseGrid :houses="currentList" />
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    components: {
        HouseGrid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v1_grid"*/ '../../md-house/grid-v1/grid.vue'
            ))
    },
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';
.md-similar-home.classic {
    .mg-title {
        position: relative;
        .unlike {
            cursor: pointer;
            color: #282828;
            font-size: 15px;
            font-family: var(--font-normal);
            letter-spacing: 0px;
            position: absolute;
            right: 0px;
            top: calc(50% - 10px);
            transform: translateY(-50%);
            .iconfont {
                font-size: 18px;
            }
        }
    }
    .subTitle {
        font-family: var(--font-nomal);
        color: #787878;
        font-size: 16px;
        letter-spacing: 1px;
        white-space: pre-wrap;
        text-align: var(--mg-title-align);
    }
    @include media-600 {
        .subTitle {
            font-size: 12px;
        }
    }
}
</style>
